const listAttributes = [
  'type',
  'leadId',
  'gradYear',
  'school',
  'schoolId',
  'schoolLabel',
  'firstName',
  'lastName',
  'parentFirstName',
  'parentLastName',
  'email',
  'phoneNumber',
  'parentEmail',
  'parentPhoneNumber',
] as const;

const getAttributes = [
  ...listAttributes,
  'creationDatetime',
  'gradYear',
  'school',
  'birthday',
  'streetAddress',
  'country',
  'postcode',
] as const;

// `schoolLabel` is derived, never accepted from a caller: the leads entity resolves it
// from `schoolId` and injects it before encoding, so it must survive this mask
const updateAttributes = [
  'firstName',
  'lastName',
  'gradYear',
  'school',
  'schoolId',
  'schoolLabel',
  'email',
  'phoneNumber',
  'birthday',
  'parentFirstName',
  'parentLastName',
  'parentEmail',
  'parentPhoneNumber',
  'streetAddress',
  'country',
  'postcode',
] as const;

const convertAttributes = [
  'firstName',
  'lastName',
  'gradYear',
  'school',
  'schoolId',
  'email',
  'phoneNumber',
  'birthday',
  'parentFirstName',
  'parentLastName',
  'parentEmail',
  'parentPhoneNumber',
  'streetAddress',
  'country',
  'postcode',
] as const;

const requiredConvertAttributes = [
  'firstName',
  'lastName',
  'gradYear',
  'school',
  'schoolId',
  'email',
  'phoneNumber',
  'parentEmail',
  'parentPhoneNumber',
] as const;

const searchAttributes = [
  'gradYear',
  'firstName',
  'lastName',
  'parentFirstName',
  'parentLastName',
  'email',
  'phoneNumber',
  'parentEmail',
  'parentPhoneNumber',
  'school',
] as const;

export const LeadAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
  Convert: convertAttributes,
  RequiredConvert: requiredConvertAttributes,
  Search: searchAttributes,
};
